document.addEventListener('DOMContentLoaded',()=>{
 const sticky=document.querySelector('[data-sy-sticky]');
 const form=document.querySelector('product-info product-form');
 if(sticky&&form){const observer=new IntersectionObserver(entries=>{sticky.classList.toggle('is-visible',!entries[0].isIntersecting&&window.scrollY>500)},{threshold:0});observer.observe(form);window.addEventListener('scroll',()=>{if(window.scrollY<400)sticky.classList.remove('is-visible')},{passive:true});}
 document.querySelectorAll('.sy-mobile-nav-panel a').forEach(link=>link.addEventListener('click',()=>link.closest('details').removeAttribute('open')));
});

// Keep draft-product navigation usable inside Shopify's signed preview only.
document.addEventListener('DOMContentLoaded',()=>{
 if(!location.hostname.endsWith('.shopifypreview.com'))return;
 try{
  if(location.pathname==='/products_preview'&&new URLSearchParams(location.search).has('preview_key'))sessionStorage.setItem('seyunProductPreview',location.href);
  const preview=sessionStorage.getItem('seyunProductPreview');
  if(preview&&new URL(preview).origin===location.origin)document.querySelectorAll('a[href="/products/seyun-even-tone-body-bar"]').forEach(a=>a.href=preview);
 }catch(error){/* Storage may be disabled; canonical links remain available. */}
});
